<template>
    <label class="LineInputBlock">
        <PhoneNumberInput
            id="phone"
            v-model="inputValue"
            @update:model-value="onChange"
        />
    </label>
</template>

<script lang="ts">
    import { Component, Watch } from 'vue-property-decorator';

    import Icon from '@/components/common/Icon.vue';
    import PhoneNumberInput from '@/components/forms/PhoneNumberInput.vue';
    import FieldComponent from '@/fields/FieldComponent';
    import PhoneNumberValue from '@/fields/interfaces/PhoneNumber';

    @Component({
        emits: [ 'change' ],
        components: { PhoneNumberInput, Icon },
    })
    export default class PhoneNumber extends FieldComponent<PhoneNumberValue> {
        private inputValue: PhoneNumberValue = this.value || '';

        @Watch('value')
        private onValueChange(value: PhoneNumberValue) {
            this.inputValue = value;
        }

        private onChange() {
            this.$emit('change', this.inputValue);
        }
    }
</script>
